import React, { Component, useContext, useEffect, useRef, useState } from 'react'
import { withRoutePane } from '@/components/hoc/routePane'
import { RProps } from '@/config/props';
import { drawing } from '@/interface/constage';
import { Button, Modal, Spin, message } from 'antd';
import './three-page.less';
import axios from '@/config/axios';
import { AmbientLight, Box3, BoxGeometry, BufferGeometry, Camera, DirectionalLight, Color, DoubleSide, Float32BufferAttribute, LessDepth, Mesh, MeshBasicMaterial, MeshPhongMaterial, MeshStandardMaterial, Object3D, OrthographicCamera, PerspectiveCamera, Scene, WebGLRenderer } from "three";
import { addMonitorObjectPrimitive, findMonitorObjectPrimitiveByProjectId, findPrimitivesInProject, deleteMonitorObjectPrimitive, updateMonitorObjectPrimitive } from '@/config/api/primitives';
import { MonitorObjectPrimitive, Primitive } from '@/interface/primitive';
import { FBXLoader } from 'three/examples/jsm/loaders/FBXLoader.js';
import classNames from "classnames";
import { ReactComponent as InfoSvg } from './icons/info.svg';
import { ReactComponent as InfoBlueSvg } from './icons/info-blue.svg';
import { ReactComponent as EditSvg } from './icons/edit-white.svg';
import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer.js';
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass.js';
import { useLocation } from 'react-router-dom';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';
import { ProjectContext } from '@/config/context'
import { mobject } from '@/interface/mobject';
import { queryMobjects } from '@/config/api/mobject';
import { MobjectBaseType } from '@/utils/type';
import flushSync from 'react-dom'
import ReactDOM from 'react-dom';
import { ThreeViewChange } from './three-view-change';
import { ReactComponent as PanSvg } from '@/routes/drawing/icons/pan.svg';
import { ReactComponent as RotateSvg } from '@/routes/drawing/icons/rotate.svg';
import { ReactComponent as PanBlueSvg } from '@/routes/drawing/icons/pan-blue.svg';
import { ReactComponent as RotateBlueSvg } from '@/routes/drawing/icons/rotate-blue.svg';
import { SHOW_TYPE } from '@/routes/drawing/drawing-list';

export const VIEW_STATE = {
    NONE: - 1,
    ROTATE: 0,
    DOLLY: 1,
    PAN: 2,
    TOUCH_ROTATE: 3,
    TOUCH_PAN: 4,
    TOUCH_DOLLY_PAN: 5,
    TOUCH_DOLLY_ROTATE: 6
}
export enum CAMERA_TYPE {
    Orthographic,
    Perspective
}
interface IProps extends RProps {

}
interface IState {
    drawings: drawing[]
    isEdit: boolean
    currentDrawing: drawing
    onLinkState: boolean
}

interface MObjectPrimitive extends mobject {
    project_id?: number,//关联信息属于哪个项目
    primitive_uuid?: string,//关联的图元的UUID
}

const projectUuid = "projectUuid-wx"
const modelUuid = "modelUuid"

export const ThreePage = () => {
    const viewportId = "viewportId";
    const cameraType = CAMERA_TYPE.Perspective
    const cameraEdge = 30

    // const stats = useRef<Stats>();
    const camera = useRef<Camera>(null)
    const scene = useRef<Scene>(null)
    const renderer = useRef<WebGLRenderer>(null)
    const viewChange = useRef<ThreeViewChange>(null)
    // const controls = useRef<OrbitControls>(null)

    const [activeEntityUuid, setActiveEntityUuid] = useState<string>("")
    const activeEntity = useRef<Object3D>(null)

    const [mobjects, setMobjects] = useState<MObjectPrimitive[]>([]);    // 使用状态来存储从后端获取的 mobjects 列表（并补充了图元关联表的相关字段）
    const [loading, setLoading] = useState<boolean>(false)

    const mobjectsRef = useRef<MObjectPrimitive[]>([])

    const [editStates, setEditStates] = useState<number>(0)

    const [showType, setShowType] = useState<number>(1)
    const monitorObjectRef = useRef<Object3D[]>([])
    const showObjectRef = useRef<Object3D[]>([])
    const isInit = useRef<boolean>(false)

    useEffect(() => {
        if (!isInit.current) return
        if (!(showType == SHOW_TYPE.MONITOR || showType == SHOW_TYPE.SHOW)) return
        let remvoeList = []
        let addList = []
        if (showType == SHOW_TYPE.SHOW) {
            remvoeList = monitorObjectRef.current
            addList = showObjectRef.current
        } else {
            addList = monitorObjectRef.current
            remvoeList = showObjectRef.current
        }
        // 清空场景
        for (let i = 0; i < remvoeList?.length; i++) {
            let midObj = remvoeList[i]
            if (midObj && midObj.parent) {
                midObj.parent.remove(midObj)
            }
        }
        // 添加场景
        let allBox = new Box3()
        for (let i = 0; i < addList?.length; i++) {
            scene.current.add(addList[i])
            allBox.expandByObject(addList[i]);
        }
        allBox.getCenter(viewChange.current.rotateCenter)
        viewChange.current?.showAllEntities(allBox)
        renderer?.current?.render(scene?.current, camera?.current)

    }, [showType])

    useEffect(() => {
        camera.current = createCamera(cameraEdge, cameraType);
        scene.current = initScene()
        renderer.current = createRenderer();

        // 初始化视图控制器
        viewChange.current = new ThreeViewChange(renderer.current.domElement, camera.current, scene.current, changeSelect, resetEdit)


        // 初始化数据与旋转中心
        let allBox: Box3 = new Box3()
        generateData(allBox)
        window.addEventListener('resize', onWindowResize);

        return (() => {
            window.removeEventListener('resize', onWindowResize);
        })
    }, [])

    const resetEdit = () => {
        setEditStates(0)
    }

    const onWindowResize = () => {
        const root = document.getElementById(viewportId);
        if (!root) return;
        const aspect = root.offsetWidth / root.offsetHeight;
        if (!camera.current) return
        camera.current.left = camera.current.bottom * aspect;
        camera.current.right = camera.current.top * aspect;
        camera.current.updateProjectionMatrix();
        renderer.current.setSize(root.offsetWidth, root.offsetHeight);
        renderer.current.setViewport(0, 0, root.offsetWidth, root.offsetHeight)
    }

    const generateData = (allBox: Box3) => {
        setLoading(true)
        let projectId = 66
        Promise.all([
            queryMobjects({ project_id: projectId }),
            findMonitorObjectPrimitiveByProjectId(projectId)
        ]).then(([mobjectsRes, primitivesRes]) => {
            if (mobjectsRes.status === 200 && primitivesRes.status === 200) {
                const mobjectList: mobject[] = mobjectsRes.data || [];
                const monitorPrimitives: MonitorObjectPrimitive[] = primitivesRes.data || [];
                // 遍历 mobjectList，找到与每个 mobject 匹配的 primitive
                const updatedMobjects = mobjectList.map((mobject) => {
                    const matchingPrimitive = monitorPrimitives.find(
                        (primitive) => primitive.monitor_object_id === mobject.id
                    );

                    // 如果找到匹配项，则将 primitive_uuid 添加到 mobject 中
                    return matchingPrimitive
                        ? { ...mobject, primitive_uuid: matchingPrimitive.primitive_uuid }
                        : mobject;
                });
                setMobjects(updatedMobjects); // 更新 mobjects 状态
                mobjectsRef.current = [...updatedMobjects]
            } else {
                message.error("获取列表或关联数据失败");
            }
            return findPrimitivesInProject(projectUuid, modelUuid, SHOW_TYPE.MONITOR)
        }).then(res => {
            let primitiveList: Primitive[] = res.data || []
            for (let i = 0; i < primitiveList.length; i++) {
                let position = new Float32BufferAttribute(primitiveList[i].properties.position, 3)
                let geometry: BufferGeometry = new BufferGeometry()
                geometry.setAttribute("position", position)
                let color
                let isA = false
                if (mobjectsRef.current.find(item => primitiveList[i].uuid == item.primitive_uuid)) {
                    color = new Color(0, 0, 1)
                    isA = true
                } else {
                    // color = new Color(0x000000)
                    color = new Color(0, 0, 1)
                    isA = false
                }
                let material = new MeshStandardMaterial({
                    side: DoubleSide,
                    emissive: isA ? 0x222222 : 0x444444,
                    opacity: isA ? 1 : 1,
                    // opacity: 1,
                    transparent: true,
                    depthFunc: LessDepth,
                    color: color,
                    depthTest: false
                })
                geometry.computeBoundingBox();
                geometry.computeBoundingSphere();
                geometry.computeVertexNormals();
                let midMesh: Mesh = new Mesh(geometry, material)
                midMesh.renderOrder = 10000
                midMesh.uuid = primitiveList[i].uuid
                monitorObjectRef.current.push(midMesh)
                scene.current.add(midMesh)
                // 更新包围盒
                let midBox = new Box3().setFromBufferAttribute(position)
                allBox.union(midBox)
            }
            if (primitiveList?.length > 0) {
                allBox.getCenter(viewChange.current.rotateCenter)
                viewChange.current.showAllEntities(allBox)
                animate()
            }
        }).finally(() => {
            loadFbxFile()
            isInit.current = true
        })
    }

    // 加载FBX模型
    const loadFbxFile = () => {
        const fbxLoader = new FBXLoader();
        if (!scene.current) return
        fbxLoader.load(
            '/api/static/model/model.fbx',
            (fbx) => {
                console.log('FBX model loaded successfully!', fbx);
                // 用来存储所有生成的 JSONy 数据
                const model = fbx;
                // 遍历模型的材质，设置透明度
                model.traverse((child) => {
                    if (child.isMesh) {
                        if (child.material) {
                            if (Array.isArray(child.material)) {
                                // 如果材质是数组
                                child.material.forEach((mat) => {
                                    mat.transparent = true; // 开启透明
                                    // mat.opacity = buildingOpacity; // 设置透明度
                                });
                            } else {
                                // 单一材质
                                child.material.transparent = true;
                                // child.material.opacity = buildingOpacity;
                            }
                        }
                    }
                });
                // 将模型添加到场景
                model.position.set(0, 0, 0);
                // console.log('model', model)
                scene.current.add(model);
                setLoading(false)
                // animate()
                renderer?.current?.render(scene?.current, camera?.current)
            },
            undefined,
            (error) => {
                setLoading(false)
                animate()
                console.error('Error loading GLB model:', error);
            }
        );
    };

    const oldColor = useRef<Color>(null)
    const oldSelect = useRef<Object3D>(null)
    //点击图元的回调函数
    const changeSelect = (entities: Object3D[]) => {
        // 判断是否选中绑定元素
        let bindEntities = entities.filter(item =>
            mobjectsRef.current.find(mItem => mItem.primitive_uuid == item.uuid) &&
            item.uuid != oldSelect.current?.uuid
        )
        let entity
        if (bindEntities?.length > 0) {
            entity = bindEntities[bindEntities.length - 1]
        }

        if (oldSelect.current) {
            oldSelect.current.material.color = oldColor.current
        }
        setActiveEntityUuid(entity?.uuid)
        activeEntity.current = entity
        if (entity) {
            oldColor.current = entity.material.color.clone()
            oldSelect.current = entity
            entity.material.color = new Color(0x00ff00)
        } else {
            // 如果 entity 为空，清空 activeEntityUuid 并隐藏信息
            setActiveEntityUuid("");
            oldColor.current = null
            oldSelect.current = null
        }
    }


    const createCamera = (s = 30, cameraType = CAMERA_TYPE.Orthographic) => {
        const root = document.getElementById(viewportId);
        if (!root) return null;
        const aspect = root.offsetWidth / root.offsetHeight;
        if (cameraType === CAMERA_TYPE.Orthographic) {
            const camera = new OrthographicCamera(-s * aspect, s * aspect, s, -s, 0.1, 1e7);
            camera.position.set(-1e7 / 2, -1e7 / 2, 1e7 / 2)
            camera.up.set(0, 0, 1)
            camera.lookAt(0, 0, 0)
            return camera;
        } else if (cameraType === CAMERA_TYPE.Perspective) {
            const fov = 75;
            const camera = new PerspectiveCamera(fov, aspect, 0.1, 1e7);
            camera.position.set(0, 0, 300000)
            camera.lookAt(0, 0, 0)
            return camera;
        }
        return null;
    }

    const createRenderer = () => {
        const root = document.getElementById(viewportId);
        if (!root) return null;
        root.oncontextmenu = (e) => {
            e.preventDefault();
        }
        const renderer = new WebGLRenderer({
            antialias: true,
            logarithmicDepthBuffer: true
        });
        // renderer.setPixelRatio(window.devicePixelRatio);
        renderer.setSize(root.offsetWidth, root.offsetHeight);
        renderer.setClearColor('#f5f5f5', 1.0);
        renderer.autoClear = false;
        renderer.domElement.style.background = 'rgb(0,21,54)';


        renderer.setAnimationLoop(animate);
        root.appendChild(renderer.domElement);
        return renderer;
    }

    const initScene = () => {
        let scene = new Scene();

        // 在初始化部分添加光源
        // 添加光照
        const ambientLight = new AmbientLight(0xffffff, 1);
        scene.add(ambientLight);

        const directionalLight = new DirectionalLight(0xffffff, 1);
        directionalLight.position.set(1, 0, 0).normalize();
        directionalLight.castShadow = true; // 使光源投射阴影
        scene.add(directionalLight);

        const directionalLight1 = new DirectionalLight(0xffffff, 1);
        directionalLight1.position.set(-1, 0, 0).normalize();
        directionalLight1.castShadow = true; // 使光源投射阴影
        scene.add(directionalLight1);
        const directionalLight2 = new DirectionalLight(0xffffff, 1);
        directionalLight2.position.set(0, 1, 0).normalize();
        directionalLight2.castShadow = true; // 使光源投射阴影
        scene.add(directionalLight2);
        const directionalLight3 = new DirectionalLight(0xffffff, 1);
        directionalLight3.position.set(0, -1, 0).normalize();
        directionalLight3.castShadow = true; // 使光源投射阴影
        scene.add(directionalLight3);
        const directionalLight4 = new DirectionalLight(0xffffff, 1);
        directionalLight4.position.set(0, 0, -1).normalize();
        directionalLight4.castShadow = true; // 使光源投射阴影
        scene.add(directionalLight4);

        // const boxGeometry = new BoxGeometry(10000, 10000, 10000);
        // const boxMaterial = new MeshBasicMaterial({ color: 0x00ff00 }); // 绿色
        // const box = new Mesh(boxGeometry, boxMaterial);
        // scene.add(box);

        return scene
    }

    const animate = () => {
        renderer.current.render(scene.current, camera.current)
    }

    useEffect(() => {
        if (!viewChange.current) return
        viewChange.current.changeViewState(editStates)
    }, [editStates])

    return (
        <Spin
            tip={`加载中`}
            spinning={loading}
            wrapperClassName='three-drawing-spin-main'
        >
            <div className={classNames("draw-main", {
                "draw-main-pan": editStates === 1, // 当 editStates 为 1 时添加 pan 类
                "draw-main-rotate": editStates === 2 // 当 editStates 为 2 时添加 rotate 类
            })}>
                <div className={classNames("draw-icon-group")}>
                    <div className={classNames({
                        "icon": true,
                        "selected": editStates == 1,
                    })} onClick={() => setEditStates(editStates == 1 ? 0 : 1)}>
                        {editStates == 1 ? <PanSvg /> : <PanBlueSvg />}
                    </div>
                    <div className={classNames({
                        "icon": true,
                        "selected": editStates == 2,
                    })} onClick={() => setEditStates(editStates == 2 ? 0 : 2)}>
                        {editStates == 2 ? <RotateSvg /> : <RotateBlueSvg />}
                    </div>
                </div>
                <div
                    id={viewportId}
                    className="viewport">
                </div>
            </div>
        </Spin>


    )
}
